import api from './api';
import mongoose from 'mongoose';

import { Driver } from '../interfaces/drivers.interface';


export class DriverService {
  async getDrivers() {
    return api.get("/drivers");
  }
  
  async getCurrentDriver() {
    return api.get("/drivers/me");  // Changed from "/drivers/current" to "/drivers/me"
  }
  
  async updateDriver(id: string, driver: Partial<Driver>) {
    return api.put(`/drivers/${id}`, driver);
  }
  
  async addDriver(driver: Omit<Driver, '_id'>) {
    let id: string = new mongoose.Types.ObjectId().toString();
    return api.post("/drivers", { ...driver, _id: id });
  }
  
  async deleteDriver(id: string) {
    return api.delete(`/drivers/${id}`);
  }

  isDriverActive(driver: Driver): boolean {
    return driver.manuallyActive && new Date() < new Date(driver.expirationDate);
  }
}
